import React from 'react';
import { ReactComponent as CheckmarkIcon } from "../../../assets/svgs/checkmark-fill-circle-icon.svg";
import { ReactComponent as OnpremIcon } from "../../../assets/svgs/onprem-default.svg";

import "./cvoWeCardNew.scss";

const OnpremWeCard = {
    className: () => "cvo-we-card",
    renderContent: ({data}) => {
        const {name} = data;
        return (<>
                <div className="checkmark"><CheckmarkIcon/></div>
                <div className="card-content">
                    <div className="card-icon"><OnpremIcon/></div>
                    <div className="card-details">
                        <div className="we-name">{name}</div>
                        <div className="we-details">
                            <CardDetail value={data.status?.status || 'N/A'} name="Status"/>
                        </div>
                    </div>
                </div>
            </>
        )
    }
};

export default OnpremWeCard;

const CardDetail = ({value, name}) => {
    return <div className="card-detail">
        <div className="value" title={value}>{value}</div>
        <div className="name">{name}</div>
    </div>
};
